import React from "react";
import { Flex, HStack, Stack, VStack, Box } from "@chakra-ui/react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

const Layout = () => {
  return (
    <VStack h="100vh" w="100vw" align="flex-start" spacing={0} overflow="hidden">
      {/* Header */}
      <HStack bg="#fff" w="full" h="16">
        <Header />
      </HStack>

      {/* Body */}
      <Flex h="full" w="full" position="relative">
        {/* Sidebar - Fixed + Scrollable + Hidden Scrollbar */}
        <Box
          display={["none", "none", "none", "block"]}
          position="fixed"
          top="4rem"
          left="0"
          height="calc(100vh - 4rem)"
          width="13rem"
          bg="#fff"
          overflowY="auto"
          zIndex="100"
          borderRight="1px solid #eee"
          sx={{
            scrollbarWidth: "none",          // Firefox
            "&::-webkit-scrollbar": {
              display: "none",               // Chrome/Safari
            },
          }}
        >
          <Sidebar />
        </Box>

        {/* Main Content (Outlet) - Scrollable & Hidden Scrollbar */}
        <Stack
          h="calc(100vh - 4rem)"
          w="full"
          ml={["0", "0", "0", "13rem"]}
          overflowY="auto"
          bg="#FAFBFE"
          p="20px"
          sx={{
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Outlet />
        </Stack>
      </Flex>
    </VStack>
  );
};

export default Layout;
